const certificates = [
  {
    title: 'THE ROLLING SCOPES SCHOOL JS/FE PRE-SCHOOL 2022Q2 (JAVASCRIPT)',
    link: 'https://app.rs.school/certificate/ecw26weg',
    img: './images/certificates/preRS.png',
  },
  {
    title: 'THE ROLLING SCOPES SCHOOL JAVASCRIPT/FRONT-END 2022Q3 (JAVASCRIPT)',
    link: 'https://app.rs.school/certificate/d90px16p',
    img: './images/certificates/RS.png',
  },
  {
    title: 'FRONT END DEVELOPMENT LIBRARIES',
    link:
      'https://www.freecodecamp.org/certification/lickoneyou/front-end-development-libraries',
    img: './images/certificates/reactCert.png',
  },
  {
    title: 'JavaScript Algorithms and Data Structures Certification',
    link:
      'https://www.freecodecamp.org/certification/lickoneyou/javascript-algorithms-and-data-structures',
    img: './images/certificates/Algorithms.png',
  },
  {
    title: 'JavaScript Algorithms and Data Structures (Beta)',
    link:
      'https://www.freecodecamp.org/certification/lickoneyou/javascript-algorithms-and-data-structures-v8',
    img: './images/certificates/algorithms(beta).png',
  },
  {
    title: 'Responsive Web Design',
    link:
      'https://www.freecodecamp.org/certification/lickoneyou/responsive-web-design',
    img: './images/certificates/WD.png',
  },
]

export default certificates
